import { render, staticRenderFns } from "./contractReminder.vue?vue&type=template&id=2f23ea0a&"
import script from "./contractReminder.vue?vue&type=script&lang=js&"
export * from "./contractReminder.vue?vue&type=script&lang=js&"
import style0 from "./contractReminder.vue?vue&type=style&index=0&id=2f23ea0a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports